<template>
  <div class="video__wrapper">
    <video
      ref="video"
      class="video__element"
      loop
      muted=""
      playsinline=""
      disableRemotePlayback
      preload="metadata"
      width="100%"
      autoplay
      :style="{ 'background-image': `url(${poster})` }"
      @stalled="attemptVideoRecovery"
      @waiting="attemptVideoRecovery"
    >
      <source
        v-for="source in sources"
        :key="source.url"
        :src="source.url"
        :type="source.mimeType"
      />
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
export default {
  name: "Video",
  props: {
    video: {
      type: Object,
      required: true,
    },
    intersected: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["lowPower"],
  computed: {
    sources() {
      return this.video.sources;
    },
    poster() {
      if (this.video.previewImage) {
        return this.video.previewImage.url;
      }
      return null;
    },
  },
  watch: {
    intersected(newVal, oldVal) {
      if (oldVal === false && newVal === true) {
        this.playVideo();
      }
    },
  },
  mounted() {
    if (this.intersected) {
      this.playVideo();
    }
  },
  methods: {
    async playVideo() {
      try {
        await this.$refs["video"].play();
      } catch (error) {
        console.warn(error);
        if (
          error.message.includes(
            "The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission"
          )
        ) {
          this.$refs["video"].setAttribute("controls", true);
          this.$emit("lowPower");
        }
      }
    },
    async attemptVideoRecovery(event) {
      const video = event?.target;
      if (!video || video.dataset.recovered === "true") return;

      video.dataset.recovered = "true";

      try {
        video.load();
        await video.play();
      } catch (error) {
        // Best-effort recovery only; keep silent to avoid noisy logs.
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.video__wrapper {
  height: 100%;
}

.video__element {
  display: block;
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center center;
}

.low-power-picture {
  height: 100%;

  .picture {
    height: 100%;
  }
}
</style>
